import createMappedReducer from 'src/common/reducers/utils/createMappedReducer';
import playerStatuses from 'src/common/utils/playerStatuses';
import * as PrerollActions from '../actions/preroll';
import * as PlayerActions from '../actions/player';

// Preroll action
function onPrerollStart(state, action) {
  return {
    ...state,
    playerState: playerStatuses.loaded,
    videoWidth: action.videoWidth,
    videoHeight: action.videoHeight,
  };
}

function hidePrerollPlayer(state) {
  return {
    ...state,
    playerState: playerStatuses.stopped,
    prerollDialogOpen: false,
    learnMoreUrl: undefined,
  };
}

// Preroll video actions
function showPrerollPlayer(state) {
  return {
    ...state,
    prerollDialogOpen: true,
  };
}

function setPrerollProgress(state, action) {
  return {
    ...state,
    timeData: action.timeData,
  };
}

function setPrerollPausedState(state) {
  return {
    ...state,
    playerState: playerStatuses.paused,
  };
}

function setPrerollPlayingState(state) {
  return {
    ...state,
    playerState: playerStatuses.playing,
  };
}

function minimizePrerollPlayer(state) {
  return {
    ...state,
    isMinimized: true,
  };
}

function expandPrerollPlayer(state) {
  return {
    ...state,
    isMinimized: false,
  };
}

function setVolume(state, action) {
  return {
    ...state,
    volume: action.volume,
  };
}

function setPrerollLearnMoreUrl(state, action) {
  return {
    ...state,
    learnMoreUrl: action.url,
  };
}

const initialState = {
  playerState: playerStatuses.idle,
  prerollDialogOpen: false,
  isMinimized: false,
  timeData: {},
};

export const preroll = createMappedReducer(initialState, {
  [PrerollActions.PREROLL]: onPrerollStart,
  [PrerollActions.PREROLL_ERROR]: hidePrerollPlayer,
  [PrerollActions.SHOW_PREROLL_PLAYER]: showPrerollPlayer,
  [PrerollActions.HIDE_PREROLL_PLAYER]: hidePrerollPlayer,
  [PrerollActions.PREROLL_PROGRESS]: setPrerollProgress,
  [PrerollActions.PREROLL_PAUSED]: setPrerollPausedState,
  [PrerollActions.PREROLL_RESUMED]: setPrerollPlayingState,
  [PrerollActions.MINIMIZE_PREROLL_PLAYER]: minimizePrerollPlayer,
  [PrerollActions.EXPAND_PREROLL_PLAYER]: expandPrerollPlayer,
  [PrerollActions.PREROLL_UPDATE_VOLUME]: setVolume,
  [PrerollActions.SET_PREROLL_LEARN_MORE_URL]: setPrerollLearnMoreUrl,
  [PlayerActions.REQUEST_TUNE]: hidePrerollPlayer,
});
